import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

// 从 localStorage 获取配置
const getStoredConfig = () => {
  const config = localStorage.getItem('qianshu_config');
  return config ? JSON.parse(config) : null;
};

// 创建 axios 实例
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000, // 增加到 30 秒
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器 - 添加 API Key
api.interceptors.request.use((config) => {
  const storedConfig = getStoredConfig();
  if (storedConfig?.apiKey) {
    config.headers['X-API-Key'] = storedConfig.apiKey;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// 响应拦截器 - 统一错误处理
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = error.response?.data?.error?.message || error.message || '请求失败';
    return Promise.reject(new Error(message));
  }
);

// API 方法
export const apiClient = {
  // 注册应用
  registerApp: (name) => api.post('/app/register', { name }),

  // 获取最新配置
  getConfig: (appId) => api.get(`/config/${appId}`),

  // 获取指定版本配置
  getConfigVersion: (appId, version) => api.get(`/config/${appId}/${version}`),

  // 更新配置
  updateConfig: (appId, config, comment) => api.post(`/config/${appId}`, { config, comment }),

  // 获取版本列表
  getVersions: (appId, limit = 20, offset = 0) => 
    api.get(`/versions/${appId}?limit=${limit}&offset=${offset}`),

  // 回滚版本
  rollback: (appId, version, comment) => 
    api.post(`/rollback/${appId}/${version}`, { comment }),

  // 删除版本
  deleteVersion: (appId, version) => 
    api.delete(`/version/${appId}/${version}`),
};

export default api;
